import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { BetterAuthError } from "../utils";
import { mcpFetch } from "./mcpFetch";
import { type McpClient, mcpClientListSchema } from "./schemas";

export const MCP_CLIENTS_QUERY_KEY = ["mcp", "clients"] as const;

/**
 * The caller's own company's MCP credentials. Scoping is the server's: it answers from
 * `reference_id`, so there is nothing to filter here and no company id to pass.
 *
 * Clients that self-register (Claude, ChatGPT) are absent by construction — they carry neither an
 * owning user nor an owning company — so this lists only what someone generated from this page or
 * had generated for them.
 */
async function fetchMcpClients(): Promise<McpClient[]> {
  return mcpFetch(
    "/oauth2/get-clients",
    mcpClientListSchema,
    { method: "GET" },
    "Could not load your MCP credentials",
  );
}

export const mcpClientsQueryOptions = () => ({
  queryKey: MCP_CLIENTS_QUERY_KEY,
  queryFn: fetchMcpClients,
});

export function useMcpClients(
  options?: Partial<
    UseQueryOptions<McpClient[], BetterAuthError, McpClient[], typeof MCP_CLIENTS_QUERY_KEY>
  >,
) {
  return useQuery({
    ...mcpClientsQueryOptions(),
    ...options,
  });
}
